export default function getTokenFromStorage(storageKey: string) {
  const data = localStorage.getItem(storageKey);

  if (!data) return null;

  const { expireTime, accessKey, jwtToken } = JSON.parse(data);
  const now = new Date();

  if (now.getTime() > expireTime) {
    localStorage.removeItem(storageKey);

    return null;
  }

  return { accessKey, jwtToken };
}
